import { PLAYER_ENV } from 'environment';

angular.module('app.directives').directive('appPlayer', () =>
    ({
        restrict: 'E',
        scope: { channelId: '=', ticketId: '=', reload: '=', onRefresh: '=' },
        template: "<div class=\"player\"></div>",
        link(scope, element, attrs, ngModel) {
            const id = `player-${0|(Math.random()*1000000)}`;
            $(element).find('.player').attr('id', id);
            let ctx = null;

            scope.$watchGroup(['channelId', 'reload'], function(values) {
                const channelId = values[0];
                if (channelId) {
                    ctx = boxcast(`#${id}`);
                    var options = {
                      disableMetrics: true,
                      autoplay: false,
                      playInline: true,
                      autostart: false,
                      ticketId: scope.ticketId,
                      env: PLAYER_ENV,
                      geoblock: {},
                      cryptblock: {},
                      onRefresh: function() {
                        scope.$apply(function() {
                          scope.onRefresh && scope.onRefresh();
                        });
                      }
                    };
                    return ctx.loadChannel(channelId, options);
                }
            });

            return element.on('$destroy', () => {
                if (ctx) ctx.unload();
            });
        }
    }));


// WEBPACK FOOTER //
// ./directives/player.js